module.exports = __webpack_public_path__ + "img/mc-r1.5f95f7ed.gif";